import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HotelManagementComponent = lazy(() => import('./hotel-management.tsx'));

export const hotelManagementRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <HotelManagementComponent />
      </Suspense>
    )
  }
];
